import React from 'react';
import { Bolt, FiberManualRecord } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { format } from 'date-fns';

import { LocalizationTypography } from '~components/organisms';

interface HeaderSuccessEjectedInformProps {
  rentedAt?: string;
  unreturnedFeeAppliesAt?: string;
  chargersLeft?: number;
}

export const HeaderSuccessEjectedInform = ({
  rentedAt,
  unreturnedFeeAppliesAt,
  chargersLeft,
}: HeaderSuccessEjectedInformProps) => {
  const formatDate = (date?: string) => {
    if (!date) return ``;
    try {
      const dateInstance = new Date(date);
      return `${format(dateInstance, 'eee, MMM d')}\n${format(
        dateInstance,
        'h:mm a',
      )}`;
    } catch {
      return '';
    }
  };

  const formattedRentedAt = formatDate(rentedAt) || '---';
  const formattedReturnsAt = formatDate(unreturnedFeeAppliesAt) || '---';

  const dot = <FiberManualRecord sx={{ width: 6 }} />;

  return (
    <Stack
      p={2.5}
      color="white"
      justifyContent="center"
      textAlign="center"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          backgroundColor: '#0b9df5',
          content: "''",
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          zIndex: '-1',
          backgroundImage: 'url(/images/banner-background.webp)',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '200% 200%',
          transform: 'rotateX(180deg)',
        },
      }}
      gap={2}
    >
      <Stack direction="row" justifyContent="center" alignItems="center">
        <img src="/images/check.svg" alt="check" width={64} />
      </Stack>
      <LocalizationTypography
        textId="app.successPage.text.chargerEjected"
        defaultText="Charger Ejected!"
        variant="Poppins/Heading-3"
      />
      {chargersLeft !== undefined && chargersLeft !== -1 && (
        <LocalizationTypography
          textId="app.successPage.text.chargersLeft"
          defaultText="{{count}} charger swaps left"
          textValues={{ count: chargersLeft }}
          variant="Inter/Subheading-sm"
        />
      )}
      <Stack flexDirection="row" sx={{ mt: 1 }} gap={1}>
        <Stack flex={1}>
          <LocalizationTypography
            textId="app.successPage.text.rentalStarts"
            defaultText="Rental started"
            variant="Inter/Subheading-sm"
          />
          <Typography variant="Poppins/Heading-4">
            {formattedRentedAt}
          </Typography>
        </Stack>

        <Stack
          flex={0.5}
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          fontSize="small"
          gap={0.25}
          color="brand.light"
        >
          {dot}
          {dot}
          <Bolt sx={{ mx: -0.25 }} />
          {dot}
          {dot}
        </Stack>

        <Stack flex={1}>
          <LocalizationTypography
            textId="app.successPage.text.rentalReturn"
            defaultText="Return by"
            variant="Inter/Subheading-sm"
          />
          <Typography variant="Poppins/Heading-4">
            {formattedReturnsAt}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
